import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "planService",
    serviceName: "shared",
    query: gql`
      query planService($plan_ids: [String]) {
        planService(plan_ids: $plan_ids) {
          data {
            id
            unit {
              id
              title
            }
            lab {
              id
              title
            }
            doctor {
              id
              lastname
              firstname
            }
            servant
            details
          }
        }
      }
    `,
  },
  update: {
    name: "updatePlan",
    serviceName: "admin",
    query: gql`
      mutation updatePlan(
        $ids: [String]!
        $title: String
        $validity_months: String
        # $quantity: String
        # $order_quantity: String
        $lab_quantity: String
        $unit_quantity: String
        $doctor_quantity: String
        # $agreement_quantity: String
        $amount: String
        $code: String
        $details: String
        $related_to: String # labratoar < ,unit
      ) {
        updatePlan(
          ids: $ids
          title: $title
          validity_months: $validity_months
          # quantity: $quantity
          # order_quantity: $order_quantity
          lab_quantity: $lab_quantity
          unit_quantity: $unit_quantity
          doctor_quantity: $doctor_quantity
          # agreement_quantity: $agreement_quantity
          amount: $amount
          code: $code
          details: $details
          related_to: $related_to
        ) {
          messages
          influenced_count
        }
      }
    `,
  },
};

export default schema;
